import { Link, LinkProps } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { system, SystemProps } from '@sternum/styled-system';

export const LinkTo = styled(Link)<
  LinkProps & React.RefAttributes<HTMLAnchorElement> & SystemProps & { hoverUnderline?: boolean }
>`
  color: inherit;
  text-decoration: unset;

  &:hover {
    ${(props) => {
      if (props.hoverUnderline === true) {
        return css`
          text-decoration: underline;
        `;
      }

      if (props.hoverUnderline === false) {
        return css`
          text-decoration: unset;
        `;
      }
    }}
  }

  ${system}
`;
